import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import { AccountFooter } from 'components/Footer/AccountFooter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  useGetCompanyForScheduledBillingQuery,
  usePostGenerateBillArScheduledBillingMutation,
  useReverseScheduledBillingMutation,
} from 'generated/graphql'
import { getCreatedByName, getUserNameByID } from 'helpers/AuditUserName'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import { ReverseDialogV2 } from 'components/Dialog/ReverseDialogV2'

export const ARGenerateScheduledBillingEntryList = (props: any) => {
  const {
    userList,
    filteredList,
    ScheduledBillingbyStatusLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
    setErrMessage,
    setErrDialog,
    postIDs,
    setPostIDs,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const companyStatus = localStorage?.getItem('companyStatus')

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteAA, setDeleteAA] = useState(false)
  const [reverse, setReverse] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')
  const [isCombined, setIsCombined] = useState(false)

  const handleCheckboxChange = event => {
    setIsCombined(event.target.checked)
  }
  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  console.log('menu: ', menu)

  // handle checkbox for all employee
  const handleSelectAll = e => {
    let temp = postIDs
    if (e.target.checked) {
      filteredList.map(v => {
        temp.add(v?.ScheduledBillingItemID)
      })
    } else {
      temp.clear()
    }
    setPostIDs(new Set(temp))
  }

  // handle checkbox for specific entityCoa
  const handleCheckBoxChange = (e: any, postID, index: number) => {
    let temp = postIDs
    if (!temp.has(postID)) {
      temp.add(postID)
    } else {
      temp.delete(postID)
    }

    setPostIDs(new Set(temp))
  }

  let listPostIDs: any = Array.from(postIDs || [])

  let checkedData = []
  listPostIDs.map(ID => {
    filteredList.map((el, i) => {
      if (el?.ScheduledBillingItemID === ID) {
        checkedData.push(...el?.ScheduledBillingItemID)
      }
    })
  })

  const {
    loading: CompanyLoading,
    data: { getCompany } = { getCompany: [] },
  } = useGetCompanyForScheduledBillingQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    postGenerateBillARScheduledBilling,
    { loading: postGenerateBillARScheduledBillingLoading },
  ] = usePostGenerateBillArScheduledBillingMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setSnackBarMsg(SystemMsgs.updateRecord())
      setOpenSnackBar(true)
      setPostIDs(new Set())
      setIsCombined(false)
      setTimeout(() => {
        history.push({
          pathname: `/account-receivable/${CompanyID}/scheduled-billing/generate-scheduled-billing`,
          state: { success: true },
        })
      }, 500)
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          isBilled: false,
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name !== '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  const [
    reverseScheduledBilling,
    { loading: reverseScheduledBillingLoading },
  ] = useReverseScheduledBillingMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setSnackBarMsg(SystemMsgs.reverseRecord())
      setOpenSnackBar(true)
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          isBilled: false,
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name !== '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  const onSubmit = (listPostIDs, isCombined) => {
    postGenerateBillARScheduledBilling({
      variables: {
        ScheduledBillingItemIDs: listPostIDs,
        isCombined: isCombined,
        CompanyID,
      },
    })
  }
  /* -------------------------------------------- */
  /*                     VARIABLE                 */
  /* -------------------------------------------- */
  const { handlePermDisabled } = usePermissionChecker()

  const handleReverse = data => {
    reverseScheduledBilling({
      variables: { ScheduledBillingItemID: data, CompanyID: CompanyID },
    })
    setReverse(false)
  }
  return (
    <>
      {CompanyLoading && <Loading />}
      {reverseScheduledBillingLoading && <Loading />}
      {ScheduledBillingbyStatusLoading && <Loading />}
      {postGenerateBillARScheduledBillingLoading && <Loading />}
      <ContentWrapper advSearch float>
        {listStatus === 'SCHEDULED' && filteredList?.length !== 0 ? (
          <div
            className="mdDesc flex-space"
            style={{
              paddingLeft: '7px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>
              <Checkbox
                onChange={handleSelectAll}
                color="primary"
                value={''}
                checked={postIDs?.size === filteredList?.length}
                style={{ marginLeft: '-5px', marginTop: '-5px' }}
                disabled={companyStatus === 'INACTIVE'}
              />
              <span style={{ marginLeft: '9px' }}>Select All</span>
            </span>

            {!getCompany[0]?.isProforma && (
              <span>
                <Checkbox
                  color="primary"
                  value={isCombined}
                  checked={isCombined}
                  onChange={handleCheckboxChange}
                  style={{ marginLeft: '-9px', marginTop: '-5px' }}
                  disabled={companyStatus === 'INACTIVE'}
                />
                <span>Combine</span>
              </span>
            )}
          </div>
        ) : null}
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID,
                    isBilled: !!(listStatus === 'BILLED'),
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                ScheduledBillingbyStatusLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                console.log('el', el)

                return (
                  <ListItem>
                    {listStatus === 'SCHEDULED' ? (
                      <FormControl
                        component="fieldset"
                        style={{ width: '16px', paddingRight: '16px' }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={el?.GRTNHeaderID}
                              onChange={e => {
                                handleCheckBoxChange(
                                  e,
                                  el?.ScheduledBillingItemID,
                                  index
                                )
                              }}
                              onClick={e => e.stopPropagation()}
                              checked={postIDs?.has(el?.ScheduledBillingItemID)}
                              color="primary"
                              style={{
                                marginLeft: '10px',
                                marginRight: '-5px',
                              }}
                              disabled={
                                companyStatus === 'INACTIVE' ? true : false
                              }
                            />
                          }
                          label=""
                          name="check"
                        />
                      </FormControl>
                    ) : null}

                    <ListItemText
                      primary={
                        <>
                          <span className="desc">
                            {`${formatDate(el?.ScheduledBillingDate)}`}
                          </span>
                          &nbsp;&nbsp;
                          <span className={`xsTitle flex-space`}>
                            {
                              el?.ScheduledBillingHeader?.DebtorAccount
                                ?.DebtorName
                            }
                          </span>
                          <span
                            className="desc"
                            style={{ justifyContent: 'end' }}
                          >
                            {el?.isBilled === false ? (
                              <>
                                {formatDate(
                                  el?.ScheduledBillingHeader?.generate_date ??
                                    el?.createdTs
                                )}
                              </>
                            ) : (
                              <>
                                <strong>{el?.Invoice?.DocNo ?? 'N/A'}</strong>
                                {` | ${formatDate(
                                  el?.ScheduledBillingHeader?.generate_date ??
                                    el?.createdTs
                                )}`}
                              </>
                            )}
                          </span>
                        </>
                      }
                      secondary={
                        <Grid container className="desc flex-space text-noflow">
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={8}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.ScheduledBillingHeader?.SalesOrder?.title}
                              </span>
                            </Grid>
                            <Grid item xs={4} style={{ textAlign: 'right' }}>
                              <IconText
                                parentStyle={{ justifyContent: 'end' }}
                                font="xxTitle c-orange"
                                children={amtStr(el?.DocAmt)}
                              />
                            </Grid>
                          </Grid>
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.BillItem?.Name}
                              </span>
                            </Grid>
                          </Grid>

                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              <div className="icon-text">
                                <Tooltip
                                  disableFocusListener
                                  title={
                                    <Fragment>
                                      <Grid container wrap="nowrap" spacing={2}>
                                        <Grid item>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                          <div style={{ fontSize: '12px' }}>
                                            {getUserNameByID(
                                              userList,
                                              el?.approvedBy
                                            ) ?? getCreatedByName(el, userList)}
                                          </div>
                                          <div style={{ fontSize: '10px' }}>
                                            {formatDate(
                                              el?.approvedTs ?? el?.createdTs
                                            )}{' '}
                                            &nbsp;
                                            {formatTime(
                                              el?.approvedTs ?? el?.createdTs
                                            )}
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Fragment>
                                  }
                                  arrow
                                  enterTouchDelay={0}
                                >
                                  <div>
                                    <IconText
                                      icon={
                                        <img
                                          src={SubmitterLog}
                                          style={{
                                            width: '12px',
                                            marginRight: '3px',
                                          }}
                                        />
                                      }
                                      font="desc"
                                    />
                                  </div>
                                </Tooltip>
                                <span className="desc text-noflow">
                                  {el?.Description}
                                </span>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      }
                    />
                    {listStatus === 'BILLED' ? (
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        aria-controls="menu-list"
                        aria-haspopup="true"
                        onClick={e => {
                          handleClick(e, el?.ScheduledBillingItemID, index, el)
                        }}
                      >
                        <MoreVert />
                      </IconButton>
                    ) : (
                      <IconButton
                        edge="end"
                        aria-label="arrow"
                        disabled={handlePermDisabled({
                          companyID: CompanyID,
                          permEnum:
                            AcctPermission.AccReceivableGenerateScheduledBillingUpdate,
                        })}
                      >
                        <KeyboardArrowRight
                          onClick={() =>
                            history.push({
                              pathname: `/account-receivable/${CompanyID}/scheduled-billing/generate-scheduled-billing/add`,
                              state: el,
                            })
                          }
                        />
                      </IconButton>
                    )}
                    {/* </ListItemSecondaryAction> */}
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <>
          <MenuItem
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                AcctPermission.AccReceivableGenerateScheduledBillingView,
            })}
            onClick={() =>
              history.push({
                pathname: `/account-receivable/${CompanyID}/scheduled-billing/generate-scheduled-billing/${menu?.obj?.ScheduledBillingItemID}/detail`,
                state: menu?.obj,
              })
            }
          >
            View
          </MenuItem>
          {(process.env.REACT_APP_LOCAL_DB === 'local' ||
            process.env.REACT_APP_LOCAL_DB === 'axifcadev' ||
            process.env.REACT_APP_LOCAL_DB === 'internal') &&
            !getCompany[0]?.isProforma && (
              <MenuItem
                disabled={handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableGenerateScheduledBillingReversal,
                })}
                onClick={() => setReverse(true)}
              >
                Reverse
              </MenuItem>
            )}
        </>
      </Menu>
      {listStatus === 'SCHEDULED' ? (
        <AccountFooter
          options={[
            {
              name: 'Bill',
              onClick: () => {
                onSubmit(listPostIDs, isCombined)
              },
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    companyID: CompanyID,
                    permEnum:
                      AcctPermission.AccReceivableGenerateScheduledBillingUpdate,
                  })
                    ? true
                    : false,
              },
            },
          ]}
        />
      ) : null}

      <ReverseDialogV2
        ID={menu?.ID}
        openReverseDialog={reverse}
        setOpenReverseDialog={setReverse}
        title={'Billing'}
        menu={menu?.obj}
        handleReverse={handleReverse}
        passID={menu.ID}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
